module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/3-2-0e4c8d2cbf85982f82a62b2790549c77.png";